import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { DesvincularContatosController } from "../../../../Controllers/Automacao/Contato/ContatoControllers";
import { IContato } from "../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import Swal from "sweetalert2";
import { useGestaoContatosNaAudiencia } from "./useGestaoContatosNaAudiencia";

export default function GestaoContatosNaAudiencia() {
    const {
        totalPaginas,
        desvincularContato,
        getAudiencia,
        lstContatos,
        lstContatosLoading,
        lstContatosExec,
        location,
        idAudiencia,
        setPage,
    } = useGestaoContatosNaAudiencia();

    const tableViewColumns: Array<ColumnDescription<IContato>> = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="historico-tooltip">
                            Desvincular Contato
                        </Tooltip>
                    }
                >
                    <button
                        className="btn btn-icon btn-outline-danger"
                        onClick={() => desvincularContato(row.ID_CONTATO)}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "DS_NOME",
            text: "Cliente / Contato",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <h5>{row.DS_NOME}</h5>
                </div>
            ),
        },
        {
            dataField: "VGV_TOTAL",
            text: "Valor Geral de Venda Total",
            formatter: (c, row) => (
                <div>
                    <span>{formatMoneyReais(row.VGV_TOTAL)}</span>
                </div>
            ),
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Empreendimento",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span>{row.DS_EMPREENDIMENTO}</span>
                </div>
            ),
        },
        {
            dataField: "DS_TIPO_CONTA",
            text: "Tipo de Conta",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span>{row.DS_TIPO_CONTA}</span>
                </div>
            ),
        },
        {
            dataField: "DS_PERFIL_FINANCEIRO_CONTA",
            text: "Perfil Financeiro da Conta",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DS_ETAPA_JORNADA",
            text: "Etapa Jornada",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "NR_UNIDADES",
            text: "Quantidades Unidades",
            headerClasses: "font-size-h8 font-weight-bold",
        },
    ];

    return (
        <>
            <div className="card card-custom p-10">
                <div className="card-header border-0 pt-5 mb-5">
                    <h4 className="card-title align-items-start flex-column">
                        Gestão de Contatos - {getAudiencia?.DS_AUDIENCIA}
                    </h4>
                    <div className="card-toolbar">
                        <Link
                            to={`/${
                                location.pathname.split("/")[1]
                            }/VincularContatos/${idAudiencia}`}
                            className="btn btn-outline-success mr-2"
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />
                            Vincular Contatos
                        </Link>
                        {/* <Link
                            to={`/${
                                location.pathname.split("/")[1]
                            }/DesvincularContatos/${idAudiencia}`}
                            className="btn btn-danger"
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />
                            Desvincular Contatos
                        </Link> */}
                        <button
                            className="btn btn-outline-danger font-weight-bold ml-2"
                            onClick={() => {
                                Swal.fire({
                                    title: "Deseja desvincular todos os contatos?",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    const idsContatos =
                                        lstContatos?.map((contato) =>
                                            Number(contato.ID_CONTATO)
                                        ) ?? [];
                                    if (result.isConfirmed) {
                                        DesvincularContatosController(
                                            Number(idAudiencia),
                                            idsContatos
                                        ).then((res) => {
                                            lstContatosExec();
                                        });
                                    }
                                });
                            }}
                        >
                            Desvincular Todos
                        </button>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="table-responsive-sm">
                        <Table
                            keyField="ID"
                            columns={tableViewColumns}
                            wrapperClasses="mw-100 custom-scroll"
                            tableView={{
                                columns: tableViewColumns,
                                sizePerPage: 10,
                                cancelYScroll: true,
                                defaultStyle: true,
                                striped: true,
                            }}
                            remote={{ pagination: true }}
                            data={lstContatos || []}
                            onTableChange={(type, newState) => {
                                setPage(newState.page);
                            }}
                            loading={lstContatosLoading}
                            totalPages={totalPaginas}
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhuma Contato encontrada
                                </div>
                            )}
                            rowStyle={{ height: 80 }}
                            bordered={false}
                            defaultStyle={{ align: "center" }}
                            striped={false}
                            rowClasses={"rowClasses"}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
